// extracted by mini-css-extract-plugin
export default {"root":"AddOnCheckboxes_root__jNld9","addOn":"AddOnCheckboxes_addOn__eGxBr","checkbox":"AddOnCheckboxes_checkbox__doni3"};